import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'linebreaks' })
export class LinebreaksPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Step 1: Normalize input (replace <br> tags & \n with newline)
    value = value.replace(/<br\s*\/?>/gi, '\n');

    // Step 2: Split by '-' or newline
    const lines = value.split(/\n|-/).map(l => l.trim()).filter(l => l);

    // Step 3: Join back with <br> and bullet style
    const formatted = lines.map(l => `• ${l}`).join('<br>');

    // Step 4: Handle double spaces
    return formatted.replace(/ {2}/g, '&nbsp;&nbsp;');
  }
}
